import React, { useState } from 'react';

// Persistent setup progress, derived entirely from live data (no stored state).
// Shown at the top of the Setup tab; auto-collapses once every step is done so it
// stays out of the way for returning users.

export default function SetupChecklist({ members = [], accounts = [], savings = [], debts = [], cats = [] }) {
  const steps = [
    { label: 'Add household members', done: members.length > 0,
      hint: 'You and anyone who earns income or owns a plan' },
    { label: 'Set everyone’s income', done: members.some(m => (m.monthlyGrossIncome || 0) > 0),
      hint: 'Gross monthly pay per member' },
    { label: 'Add accounts & balances', done: accounts.length > 0,
      hint: 'Checking, savings, loans, investments' },
    { label: 'Add savings or debt plans', done: savings.length + debts.length > 0,
      hint: 'Retirement, college, mortgage, loans…' },
    { label: 'Review Strategy & Save', done: cats.some(c => (c.planned || 0) > 0),
      hint: 'Strategy → Save all writes your Planned amounts' },
  ];
  const doneCount = steps.filter(s => s.done).length;
  const pct = Math.round((doneCount / steps.length) * 100);
  const allDone = doneCount === steps.length;

  const [collapsed, setCollapsed] = useState(allDone);

  return (
    <div className="card" style={{ borderColor: allDone ? 'var(--green)' : 'var(--border2)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
        onClick={() => setCollapsed(c => !c)}>
        <div>
          <span className="sec-label" style={{ margin: 0, color: allDone ? 'var(--green)' : undefined }}>
            {allDone ? 'Setup complete ✓' : 'Getting started'}
          </span>
          {!allDone && (
            <span style={{ fontSize: 12, color: 'var(--text3)', marginLeft: 10 }}>
              {doneCount} of {steps.length} done
            </span>
          )}
        </div>
        <span style={{ fontSize: 12, color: 'var(--text3)' }}>{collapsed ? 'Show ▼' : 'Hide ▲'}</span>
      </div>

      <div className="progress-track" style={{ marginTop: 12, height: 6 }}>
        <div className="progress-fill" style={{ width: `${pct}%`, background: allDone ? 'var(--green)' : 'var(--blue)' }} />
      </div>

      {!collapsed && (
        <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {steps.map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ flexShrink: 0, width: 20, height: 20, borderRadius: '50%', marginTop: 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700,
                background: s.done ? 'var(--green-bg)' : 'var(--surface2)',
                border: `1px solid ${s.done ? 'var(--green)' : 'var(--border2)'}`,
                color: s.done ? 'var(--green)' : 'var(--text3)' }}>
                {s.done ? '✓' : i + 1}
              </span>
              <div>
                <div style={{ fontSize: 13, color: s.done ? 'var(--text3)' : 'var(--text)',
                  textDecoration: s.done ? 'line-through' : 'none' }}>{s.label}</div>
                {!s.done && <div style={{ fontSize: 11, color: 'var(--text3)' }}>{s.hint}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
